module.exports = __webpack_public_path__ + "static/img/ent-49.2b92e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-49.jpg
// module id = Pzgs
// module chunks = 51